module.exports = __webpack_public_path__ + "static/snap-financial-logo-7307c5d4a8b0e6a138bd1534247f803f.png";